import React, {Component} from 'react';
import "./App.css";
import Impfzidenz from "./Bilder/Impfzidenz.jpg"
import Homburg from "./Bilder/Homburg.jpg"

class Geschichte extends Component {


	UNSAFE_componentWillMount(){
		window.scrollTo(0,0);
	}

render() {	
  return (	

	<div className="homeApp">
		<img src={Impfzidenz} className="I11" alt="Impfzidenzen" />	
	<div className="contentHome, Impfen">	

	<h2>Ist eine Corona-Impfung gefährlich?</h2>
	<p className="Einleitung">                   
    	Nur eine kleine Auswahl als Anregung zum Weiterstöbern.       
    </p>
		
		<div className="Ein">
			<a className="videoText"  rel="noopener" href="https://impffrei.work" target="_blank" >
				<strong>Arbeitsvermittlungsportal<br/>für impffreie Menschen</strong>
			</a>
			<br/>
			<br/>
			<a className="videoText" rel="noopener"  href="https://reitschuster.de/post/lauterbach-macht-impfopfer-zu-patienten-zweiter-klasse/" target="_blank" >
			Lauterbach macht Impfopfer zu Patienten zweiter Klasse 23.12.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=evmBoyVL89U" target="_blank" >
			Plasmidgate: weiterer Skandal bei Covid-Impfstoffen - TE Wecker am 10 12 2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=0dUH-bsdkNU" target="_blank" >
			Brisant: Höchste EU-Behörde deckt Impf-Lügen auf! 23.11.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://auf1.tv/das-grosse-interview/dr-david-e-martin-gen-spritzen-einer-der-groessten-voelkermorde-der-geschichte" target="_blank" >
			Dr. David E. Martin: „Gen-Spritzen – einer der größten Völkermorde der Geschichte“ 05.10.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=CLiv9hejgGs" target="_blank" >
			Tödliche Impfchargen - Es gab sie wirklich! Interview mit Prof. Dr. Dyker und Prof. Dr. Matysik 08.08.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://reitschuster.de/post/im-fruehjahr-2021-muss-was-passiert-sein-das-die-mortalitaet-ansteigen-liess/" target="_blank" >
			„Im Frühjahr 2021 muss was passiert sein, das die Mortalität ansteigen ließ“ 17.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Fmz_r45SMXM" target="_blank" >
			Tom Lausen: Wirksamkeit und Sicherheit der COVID-19 Impfstoffe 11.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://legitim.ch/pfizer-toetet-deine-familie-aus-profitgruenden-die-regierung-bestaetigt-dass-92-der-covid-todesfaelle-im-jahr-2022-dreifach-geimpft-waren/" target="_blank" >
			Regierung bestätigt, dass 92 % der COVID-Todesfälle im Jahr 2022 dreifach geimpft waren 10.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://auf1.tv/elsa-auf1/prof-sucharit-bhakdi-wenn-wir-jetzt-keine-angst-bekommen-grenzt-das-an-dummheit/" target="_blank" >
			Prof. Sucharit Bhakdi: "Wenn wir jetzt keine Angst bekommen, grenzt das an Dummheit!" 31.05.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://reitschuster.de/post/nun-also-doch-unterschiedliche-chargen-unterschiedliche-nebenwirkungen/" target="_blank" >
			Nun also doch: unterschiedliche Chargen, unterschiedliche Nebenwirkungen 08.05.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=HgZrZtWagGE" target="_blank" >
				Biontechs Geständnis: Verbrecher im Staatsauftrag? 02.05.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=2b4BssqK7yU&t=13s" target="_blank" >
			Geopferte Soldaten: Schäden durch die Duldungspflicht? Gast: Tom Lausen, Datenanalyst 22.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=03LyzDql0SM" target="_blank" >
			Nach Impf-Hexenjagd – Wind dreht sich: Kimmich hatte Recht. Forderung nach Minister-Entschuldigung 18.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=8kz4133-jtk" target="_blank" >
			Livestream der MWGFD-Pressekonferenz am 15.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=2muq0YexB04" target="_blank" >
			DAS IST DER GIPFEL ... 13.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://multipolar-magazin.de/artikel/sterblichkeit-und-impfung" target="_blank" >
			Sterblichkeit und Impfung: amtliche britische Zahlen zeigen eine Katastrophe 13.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://auf1.tv/elsa-auf1/strafanzeige-gegen-zulassungsbehoerde-es-geht-buchstaeblich-um-leben-und-tod/" target="_blank" >
			Strafanzeige gegen Zulassungsbehörde: „Es geht buchstäblich um Leben und Tod“ 09.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://tkp.at/2023/02/14/cdc-analyse-massenhaft-schwerste-nebenwirkungen-ohne-einschreiten-der-behoerden/" target="_blank" >
					tkp.at
					CDC Analyse: Massenhaft schwerste Nebenwirkungen - ohne Einschreiten der Behörden 14.02.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://tkp.at/2023/02/13/sinkende-lebenserwartung-in-deutschland-aerzteverband-fordert-sofortigen-impfstopp/" target="_blank" >
			Sinkende Lebenserwartung in Deutschland: Ärzteverband fordert sofortigen Impfstopp 13.02.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=nqtEBULPLAY" target="_blank" >
			Sprunghafter Anstieg 2021 von „plötzlichen Toten“ – Analyse der KBV-Daten und der Kritiken
			</a>
			<a className="videoText" rel="noopener"  href="https://auf1.tv/stefan-magnet-auf1/stammzellen-fehlen-neugeborene-schwitzten-nach-pfizer-impfung-blut/" target="_blank" >
			Stammzellen fehlen, Neugeborene schwitzten nach Pfizer-Impfung Blut 19.12.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://odysee.com/@impfen-nein-danke:b/Bhakdi-Ganze-Impfindustrie-Betrug:5" target="_blank" >
			Bhakdi: Die ganze Impfindustrie ist Betrug! 03.12.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=k07kxDFulJ0" target="_blank" >
			Welt: "Aufarbeitung" des Unrechts der Corona-Jahre sofort nötig - wow! 11.11.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/shorts/yfROIe59YOU" target="_blank" >
				Pfizer 24.10.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=cOFHOlr1LZQ" target="_blank" >
				Erstmals entschuldigt sich Politikerin bei Ungeimpften für Diskriminierung 24.10.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://t.me/auf1tv/3671" target="_blank" >
			Rekord-Übersterblichkeit in Europa: „Wirkt“ jetzt die Corona-Impfung?  29.09.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=4MCQ_2ta0Ro" target="_blank" >
				Lauterbach lobt als Vorzug der Impfung, dass man mir ihr schneller Symptome hat, als Ungeimpfte.  24.08.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=4MCQ_2ta0Ro" target="_blank" >
				Lauterbach lobt als Vorzug der Impfung, dass man mir ihr schneller Symptome hat, als Ungeimpfte.  24.08.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://auf1.tv/nachrichten-auf1/prof-soennichsen-ueber-corona-impfungen-groesster-medizinskandal-aller-zeiten/" target="_blank" >
					Prof. Sönnichsen über Corona-Impfungen: „Größter Medizinskandal aller Zeiten“  18.08.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://auf1.tv/elsa-auf1/sehr-viele-babys-werden-sterben-prof-bhakdi-warnt-vor-neuen-mrna-impfungen/" target="_blank" >
			„Sehr viele Babys werden sterben“: Prof. Bhakdi warnt vor neuen mRNA-Impfungen  18.08.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://uncutnews.ch/daten-der-us-regierung-bestaetigen-aufgrund-der-covid-impfung-einen-anstieg-der-krebsfaelle-um-143-233/"  target="_blank">
			Daten der US-Regierung bestätigen aufgrund der Covid-Impfung einen Anstieg der Krebsfälle um 143.233% 16.08.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.ardmediathek.de/video/Y3JpZDovL21kci5kZS9iZWl0cmFnL2Ntcy8xNmE3MjlhYy01YTJkLTQxM2MtYTNlNC1hNThiYjBjM2Q3YjI"  target="_blank">
			ARD FAKT:  Post-Vac-Syndrom: Corona-Impfung mit Nebenwirkungen 09.08.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://auf1.tv/stefan-magnet-auf1/schamlos-und-brandgefaehrlich-die-4-impfung-wird-ohne-jede-zulassung-gespritzt/" target="_blank" >
			Die 4. Impfung wird ohne jede Zulassung gespritzt 06.07.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://apolut.net/sucharit-bhakdi-bedrueckende-nachrichten/" target="_blank" >
			Sucharit Bhakdi – Bedrückende Nachrichten 17.05.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/zulassung-von-jj-impfstoff-in-den-usa-weiter-eingeschraenkt/" target="_blank" >
			Zulassung von J&J-Impfstoff in den USA weiter eingeschränkt 08.05.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/herzentzuendungen-bei-geimpften-haeufiger-als-bei-nicht-geimpften/" target="_blank" >
			Herzentzündungen bei Geimpften häufiger als bei Nicht-Geimpfte 29.04.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.ardmediathek.de/video/umschau/impfkomplikationen-mehr-schwere-nebenwirkungen-als-gedacht/mdr-fernsehen/Y3JpZDovL21kci5kZS9iZWl0cmFnL2Ntcy8xNDk3YThlYi1mNTVjLTRkYjYtYTg5ZC05NzcyNmIwYTBjZTM" target="_blank" >
				<strong>mdr</strong> : Impfkomplikationen: Mehr schwere Nebenwirkungen als gedacht? 26.04.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=O7MGjDB_rhk" target="_blank" >
				<strong>Expertenhearing zur Impfpflicht im Gesundheitsausschuss:</strong> Expertenhearing zur Impfpflicht im Gesundheitsausschuss: Das Statement von Dr. Strasser I Teil 1 22.04.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=q44VVgbEyrY" target="_blank" >
			<strong>Expertenhearing zur Impfpflicht im Gesundheitsausschuss:</strong> Das Statement von Dr. Strasser I Teil 2 22.04.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=2oeJd9g9tXI" target="_blank" >
			<strong>Expertenhearing zur Impfpflicht im Gesundheitsausschuss:</strong> Das Statement von Dr. Strasser I Teil 3 22.04.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=iRo92fVBnfU" target="_blank" >
			Biontech zweifelt am eigenen Produkt? 24.04.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.transparenztest.de/post/ukhsa-daten-zeigen-absurditaet-einer-impfpflicht-fuer-ueber-50jaehrige-auf" target="_blank" >
				UKHSA Daten zeigen Absurdität einer Impfpflicht für über 50 Jährige auf 04.04.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=FJ8iOwXEXxs" target="_blank" >
				2022 März Epoch Times Interview Prof. Dr. Dr. Haditsch 18.03.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://odysee.com/@reitschuster:3/220301-matysik:a" target="_blank" >
					Mangelnde Qualitätskontrolle und Geheimniskrämerei bei den Impfstoffen? Prof. Matysik im Interview 08.03.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.berliner-zeitung.de/news/wissenschaftler-darum-ist-die-impfpflicht-verfassungswidrig-li.216116" target="_blank" >
						Wissenschaftler: Darum ist die Impfpflicht verfassungswidrig 07.03.2022
					</a>
			<a className="videoText"  rel="noopener" href="https://www.mdr.de/wissen/corona-covid-anteil-von-geboosterten-auf-intensivstationen-nimmt-rasant-zu-100.html" target="_blank" >
						MDR: Anteil von Geboosterten auf den Intensivstationen nimmt rasant zu 07.03.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/der-fussabdruck-der-mrna-impfung/" target="_blank" >
				Der Fußabdruck der mRNA-Impfung 05.03.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.welt.de/politik/deutschland/article237236519/Nach-Aussagen-zu-Impfnebenwirkungen-Vorstand-der-BKK-ProVita-ist-fristlos-gekuendigt.html" target="_blank" >
				Vorstand der BKK-ProVita ist fristlos gekündigt 01.03.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.berliner-zeitung.de/news/impffolgen-krankenkasse-bkk-schreibt-brief-an-paul-ehrlich-institut-li.213676" target="_blank" >
				Impffolgen: Krankenkasse BKK schreibt Brief an Paul-Ehrlich-Institut 24.02.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/uebersterblichkeit-durch-die-impfung/" target="_blank" >
						Mehr Tote im zweiten Habjahr 2021 16.02.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.auf1.tv/stefan-magnet-auf1/neueste-erdrueckende-beweislage-covid-impfung-brandgefaehrlich/" target="_blank" >
					Neueste, erdrückende Beweislage: Covid-Impfung brandgefährlich 12.02.2022
					</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=IIHDPGP4XhQ" target="_blank" >
				Pandemie: Strategie und Impfpflicht 16.01.2022
			</a>			
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/nie-wieder-voller-immunschutz-fuer-geimpfte/" target="_blank" >
				Nie wieder voller Immunschutz für Geimpfte? 06.01.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://alschner-klartext.de/2021/12/22/bhakdi-worueber-reden-wir-noch-die-fakten-sind-eindeutig/" target="_blank" >
				Die Fakten liegen auf dem Tisch, die Fakten wurden von Arne Burkhardt vor einer Woche vorgelegt, und diese Fakten sind vernichtend! 22.12.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://telegra.ph/Offizielle-Daten-deuten-darauf-hin-dass-die-vollständig-Geimpften-bis-Ende-Januar-2022-das-erworbene-Immundefektsyndrom-entwicke-01-02" target="_blank" >
					Offizielle Daten deuten darauf hin, dass die vollständig Geimpften bis Ende Januar 2022 das erworbene Immundefektsyndrom entwickeln 
					werden 02.01.2022
					</a>
			<a className="videoText"  rel="noopener" href="https://pathologie-konferenz.de" target="_blank" >
				Pathologie Konferenz Reutlingen Teil 2  04.12.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://odysee.com/@hipsterious:3/Tod-durch-Impfung---Teil-1---Undeklarierte-Bestandteile-der-COVID-19-Impfstoffe:b" target="_blank" >
				Pathologie Konferenz Reutlingen Teil 1  28.09.2021
			</a>

			<a className="videoText"  rel="noopener" href="https://t.me/bitteltv/11680" target="_blank" >
				Na da schau her, jetzt merkt es auch Drosten 08.11.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://rumble.com/votqyz-biontech-impfung-ab-7-monaten-kein-schutz-messbar-erhhtes-krankheitsrisiko-.html" target="_blank" >
			BioNTech-Impfung: Ab 7 Monaten kein Schutz messbar“ – erhöhtes Krankheitsrisiko mit AstraZeneca 06.11.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=5pN2fU2hqtw" target="_blank" >
				Myocarditis als „seltene“ Nebenwirkung? 03.11.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://tkp.at/2021/10/29/besonderheiten-der-modifizierten-spike-proteine-in-den-impfstoffen/" target="_blank" >
				Besonderheiten der modifizierten Spike-Proteine in den experimentellen Impfstoffen
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=qyQII_JjzNo" target="_blank" >
			Antigen-Erfinder Stöcker über die Blockade durch die Regierung 24.08.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=4KD_3igxz0k" target="_blank" >
						Sucharit Bhakdi erklärt die Wirkungen der neuartigen Impfungen 03.08.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=Lr-0GKJVOIQ" target="_blank" >
			Endlich macht ein linker Politiker den Mund auf! (Raphael Bonelli) 09.08.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://tkp.at/2021/08/05/lassen-sie-sich-nicht-einschuechtern-sie-haben-recht-wissenschaftler-mit-offenem-brief-an-ungeimpfte/" target="_blank" >
				„Lassen Sie sich nicht einschüchtern, Sie haben Recht“ 05.08.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://schweizerzeitung.ch/wikipedia-loescht-den-erfinder-der-mrna-technologie/" target="_blank" >
				Wikipedia löscht den Erfinder der mRNA-Technologie 31.07.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.wochenblick.at/chef-entwicklerin-von-astrazeneca-gegen-kinder-impfung-und-auffrischungen/" target="_blank" >
				Chef-Entwicklerin von AstraZeneca gegen Kinder-Impfung und „Auffrischungen“ 22.07.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=kQ_NA1MUbIc" target="_blank" >
				mRNA-Impfstoffe: Erste Hinweise auf Langzeitfolgen (mit Clemens Arvay) 09.06.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/das-sars-cov-2-spike-protein-ist-zytotoxisch-das-ist-eine-tatsache/" target="_blank" >
				Erfinder der mRNA-Impfung: „Das SARS-CoV-2-Spike-Protein ist zytotoxisch“ 23.06.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/weltgesundheitsorganisation-kinder-sollten-nicht-gegen-corona-geimpft-werden/" target="_blank" >
				WHO: „Kinder sollten nicht gegen Corona geimpft werden!“ 22.06.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://t.me/AllesAusserMainstream/5536" target="_blank" >
				1ste ERGEBNIS der 1st Studie, zwar an Ratten 🥺 des mRNA (Eugenik!!!) Impfmittels liegt vor. 09.06.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://report24.news/dr-roger-hodkinson-warnt-spike-proteine-machen-beide-geschlechter-unfruchtbar/" target="_blank" >
				Spike Proteine machen beide Geschlechter unfruchtbar 06.06.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.bitchute.com/video/qHkhwydpUosG/" target="_blank" >
				Interview mit Prof. Dr. Sucharit Bhakdi 02.05.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/impfkampagne-in-israel-katastrophale-ergebnisse-auf-allen-ebenen/" target="_blank" >
				Impfkampagne in Israel: „Katastrophale Ergebnisse auf allen Ebenen“ 06.05.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.achgut.com/artikel/nochmal_kinderimpfung_risiko_nutzen_die_zahlen" target="_blank" >
				Kinderimpfung: Risiko/Nutzen 08.05.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://odysee.com/@KulturstudioTV:c/Impf-End:f" target="_blank" >
				IMPFUNG - DIE ENDLÖSUNG DER MENSCHHEITSFRAGE 07.05.2021
			</a>									
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=LuOu9y-Ilpk" target="_blank" >
				Corona-Impfung: Ja oder nein<br/>21.03.2021
			</a>	
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=kZSj6MhRR8g" target="_blank" >
				Corona-Impfung: Erlösung oder Risiko?<br/>20.02.2021
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=J1Py2yPyiXU" target="_blank" >
				Bundesinstitut streicht schwere Verdachtsfälle aus der Liste 07.04.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.bitchute.com/video/nhypBHn8Ule1/" target="_blank" >
				Massenimpfung könnte zu „Globaler Katastrophe epischen Ausmaßes“ führen 24.03.2021
			</a>	
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=gOdAQ6IVV1c" target="_blank" >
				Impfstoff-Propaganda<br/>Clemens Arvay 14.02.2021
			</a>							
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=pk7F-kPx3u8" target="_blank" >
				Bhakdi - Haditsch - Sönnichsen 21.02.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=O7aPL5-G_p8" target="_blank" >
				SAT1: Dr. Brandenburg 22.12.2020			
			</a>	
		
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=XNmWvem7-XI" target="_blank" >
				Spiegel: Prof. Stöcker 03.03.2021<br/>Alternative Impfung
			</a>	
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=FEAzXot1dlA" target="_blank" >
				Impfen AUFGEDECKT 21.03.2021
			</a>	


			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=LsXM502SpiU" target="_blank" >
				RTV Talk: Corona - Stimmt die Richtung? 09.01.2021
			</a>				
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=-opKoSh7lsk"  target="_blank">
				Untersuchungsausschuss Corona-Ausschuss<br/>
				Schlussstrich 2020  01.01.2021
			</a>	
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=o5Pv1FHYGLI&feature=youtu.be" target="_blank" >
				Impfung: Zunehmende Mängel in Studien, Protokollen und Nebenwirkungen<br/>02.01.2021
			</a>						

			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=kg-Icy1DCpg" target="_blank" >
				Merkel: Es wird keine neuen Freiheiten geben<br/>02.02.2021
			</a>						
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=jhmTs63okKs" target="_blank" >
				Gen-Impfung aus Sicht der Ethik<br/>Dr. med. Ruediger Dahlke<br/>08.12.2020
			</a>							
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=leDwQmiNz8A&t=1090s" target="_blank" >
				Prof. Dr. Reiss - Prof. Dr. Bhakdi	03.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=vVQkMU86U0s" target="_blank" >
				Prof. Dr. Bhakdi	09.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=Sqt3LZy0lyk" target="_blank" >
				Clemens Arvay	28.10.2020
			</a>	
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=-bPXzoH5lfc&t=358s" target="_blank" >
				Therapie tödlicher als Krankheit?<br/>mit Dr. Claus Köhnlein 04.12.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=RpqRKsXSM60" target="_blank" >
				was ist mit wirksamen Medikamenten? 24.12.2020
			</a>										
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=nwypeZBjAgI" target="_blank" >
				Dr. Krämer Doc Ulli 	22.08.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=lNmyT5_BTGA" target="_blank" >
				Dr. Bonelli	12.08.2020
			</a>

			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=Z1PU0YqtYPU" target="_blank" >
				Clemens Arvay 	10.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=kWpzfqW34lA&t=190s" target="_blank" >
				Prof. Stephan Hockertz 	24.07.2020
			</a>

			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=ygDoiJICtj0"  target="_blank">
						Amtseid der Kanzlerin
			</a>			
		</div>

	</div>
	<div className="Impfbilder">
		<img src={Impfzidenz} className="I12" alt="Impfen" />
		<img src={Homburg} className="I2" alt="Homburg" />
		
	</div>
</div>
	 
  );
};
};

export default Geschichte;
